<script>
    export let data, counties;
    import { selCounty, selSystem } from '../store.js';

    $: systemList = data.filter(function(d){ return d.main_county == $selCounty; });

    $: systemListLength = systemList.length;

    $: if (systemListLength === 1){
        selSystem.set(systemList[0].pwsid);
    }
</script>

<select name="county-selector" id="county-selector" aria-label="Select a county from the dropdown to filter" tabindex=“0”>
    <option value="" disabled selected hidden>Filter by county</option>
    {#each counties as county}
    {#if $selCounty == county }
        <option value="{county}" aria-label="{county}" selected>{county}</option>
    {:else}
        <option value="{county}" aria-label="{county}">{county}</option>
    {/if}
    {/each}
</select>

<select  name="system-selector" id="system-selector" class="disabled" aria-label="Select a system from the dropdown to filter" required="true">
    {#if $selCounty}
        {#if systemListLength === 1}
            {#each systemList as system}
                <option value="{system.pwsid}" aria-label="{system.supplier_name}" selected>{system.supplier_name}</option>
            {/each}
        {:else}
            <option value="" disabled selected hidden>Select a water provider</option>
            {#each systemList as system}
                <option value="{system.pwsid}" aria-label="{system.supplier_name}">{system.supplier_name}</option>
            {/each}
        {/if}
    {/if}
</select>